import Icon from '../Icon';
import { TimezoneDate } from '@components';

export const renderValue = (
  value: any,
  format?: DynamicColumnCompositeSubFieldType['format']
) => {
  switch (format) {
    case 'date':
      return <TimezoneDate>{value}</TimezoneDate>;

    case 'boolean': {
      if (value === undefined || value === null) return '';

      return (
        <Icon
          icon={value ? 'yes' : 'no'}
          iconStyle={value ? 'default' : 'danger'}
        />
      );
    }

    default:
      return value !== null && value !== undefined ? String(value) : '';
  }
};
